import { mix, rgba } from './utils/color-utils';
import prepareThemeColors from './utils/theme';


const brandPrimary = '#44515e';
const navAccent = '#cb333b';

export default prepareThemeColors('virtuozzo', {
  '--av-nav-primary': '#262626',
  '--av-nav-secondary': navAccent,
  '--av-nav-light': '#3b3b3b', // removed, fallback
  '--av-nav-lightest': rgba(navAccent, 0.3), // @fixme: removed?
  '--av-nav-text': '#ffffff',
  '--av-nav-text-active': '#ffffff',
  '--av-scroll-thumb': '#243143',
  '--av-scroll-thumb-inverse': 'rgba(255, 255, 255, 0.4)',
  '--av-brand-primary': brandPrimary,
  '--av-brand-light': rgba(brandPrimary, 0.3), // removed, fallback
  '--av-brand-lighter': rgba(brandPrimary, 0.1),
  '--av-brand-lightest': rgba(brandPrimary, 0.05), // @fixme: removed?
  '--av-brand-accent': rgba(brandPrimary, 0.1),
  '--av-solid-brand-accent': mix(brandPrimary, '#ffffff', 0.1),
  '--av-solid-brand-lightest': mix(brandPrimary, '#ffffff', 0.05),
  '--av-brand-secondary': 'rgb(64, 139, 234)', // @fixme: from default theme
  '--av-brand-secondary-light': 'rgba(64, 139, 234, 0.30)', // @fixme: from default theme
  '--av-brand-secondary-accent': 'rgba(64, 139, 234, 0.15)', // @fixme: from default theme
  '--av-fixed-primary': 'rgb(36, 49, 67)', // @fixme: from default theme
  '--av-fixed-secondary': 'rgba(36, 49, 67, 0.90)', // @fixme: from default theme
  '--av-fixed-light': 'rgba(36, 49, 67, 0.60)', // @fixme: from default theme
  '--av-fixed-lighter': 'rgba(36, 49, 67, 0.40)', // @fixme: from default theme
  '--av-fixed-lightest': 'rgba(36, 49, 67, 0.20)', // @fixme: from default theme
  '--av-fixed-invisible': 'rgba(36, 49, 67, 0.10)', // @fixme: from default theme
  '--av-fixed-white': 'rgb(255, 255, 255)', // @fixme: from default theme
  '--av-fixed-white-secondary': 'rgba(255, 255, 255, 0.95)', // @fixme: from default theme
  '--av-fixed-white-light': 'rgba(255, 255, 255, 0.60)', // @fixme: from default theme
  '--av-fixed-white-lighter': 'rgba(255, 255, 255, 0.40)', // @fixme: from default theme
  '--av-fixed-white-lightest': 'rgba(255, 255, 255, 0.20)', // @fixme: from default theme
  '--av-fixed-white-invisible': 'rgba(255, 255, 255, 0.10)', // @fixme: from default theme
  '--av-fixed-success': 'rgba(155, 194, 37, 1)', // @fixme: from default theme
  '--av-fixed-success-accent': 'rgba(155, 194, 37, 0.15)', // @fixme: from default theme
  '--av-fixed-success-dark': 'rgb(96, 148, 37)', // @fixme: from default theme
  '--av-fixed-success-dark-accent': 'rgba(96, 148, 37, 0.30)', // @fixme: from default theme
  '--av-fixed-warning': 'rgb(255, 163, 16)', // @fixme: from default theme
  '--av-fixed-warning-accent': 'rgba(255, 163, 16, 0.15)', // @fixme: from default theme
  '--av-fixed-critical': 'rgb(255, 114, 0)', // @fixme: from default theme
  '--av-fixed-critical-accent': 'rgba(255, 114, 0, 0.15)', // @fixme: from default theme
  '--av-fixed-danger': 'rgb(217, 44, 35)', // @fixme: from default theme
  '--av-fixed-danger-accent': 'rgba(217, 44, 35, 0.15)', // @fixme: from default theme
  '--av-solid-brand-secondary-light': 'rgb(198, 220, 249)', // @fixme: from default theme
  '--av-solid-brand-secondary-accent': 'rgb(226, 238, 252)', // @fixme: from default theme
  '--av-solid-fixed-invisible': 'rgb(233, 234, 236)', // @fixme: from default theme
  '--av-solid-fixed-success-accent': 'rgb(240, 246, 222)', // @fixme: from default theme
  '--av-solid-fixed-warning-accent': 'rgb(255, 241, 219)', // @fixme: from default theme
  '--av-solid-fixed-critical-accent': 'rgb(255, 234, 217)', // @fixme: from default theme
  '--av-solid-fixed-danger-accent': 'rgb(249, 223, 222)', // @fixme: from default theme
  '--av-fixed-link': brandPrimary,
  '--av-fixed-link-light': 'rgb(190, 210, 238)', // @fixme: from default theme
  '--av-fixed-info': 'rgb(64, 139, 234)', // @fixme: from default theme
  '--av-fixed-info-accent': 'rgba(64, 139, 234, 0.15)', // @fixme: from default theme
  '--av-fixed-focus': 'rgba(64, 139, 234, 0.30)', // @fixme: from default theme
  '--av-fixed-highlight': 'rgb(255, 223, 0)' // @fixme: from default theme
});
